import "magnific-popup";

/**
 * Dynamically Initiate pop-up
 *
 * @return {Void}
 */

function initiateProductImagePopup() {
  const productGallery = document.querySelector(
    ".product__slider.js-product-slider"
  );
  if (productGallery) {
    productGallery.addEventListener("click", function (evt) {
      const screenSize = screen.width;
      let targetImage = this.querySelector(
        ".slick-current .js-responsive-background-image"
      );

      if (
        targetImage !== null &&
        screenSize >= 768 &&
        !evt.target.classList.contains("slick-arrow")
      ) {
        let targetImageUrl = targetImage.dataset.large_image;

        $.magnificPopup.open({
          items: {
            src: targetImageUrl,
            type: "image",
          },
        });
      }

      return;
    });
  }
}

function initiateCompatibilityPopup() {
  const compatibilityPopupLink = document.querySelector(
    ".product__compatibility-popup-link"
  );
  if (compatibilityPopupLink) {
    $(".product__compatibility-popup-link").magnificPopup({
      type: "inline",
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
  }
}

initiateProductImagePopup();
initiateCompatibilityPopup();
